import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { noDefault } from 'lib/eventWrappers';

import { MissingPilotJobOrder } from 'data/models/MissingPilotJobOrders';
import { MissingPilotJobOrderType } from 'server/enums/MissingPilotJobOrderType';

import { AddPilotJobOrder, MissingPJOsDayViewModel } from './addpilotjoborder';

import { DateHeaderView } from './view';
import { PCModal } from 'portcall/pcmodal/view';

export const AddPilotJobOrderView = SuperCritical(({ modelContainer } : { modelContainer : () => AddPilotJobOrder | null }) => {
    const m = modelContainer();
    return (
        <div>
            <PCModal className="addpilotjoborder" shown={() => !!m} onBackDropClick={m?.Cancel}>
                <div className="modal-content pc-card">
                    <div className="pc-card-header pc-card-title">Movements Without Pilot Orders</div>
                    {m &&
                        <div className="modal-body">
                            {m.Days().length ?
                                <div className="days">
                                    {m.Days().map(day =>
                                        <MissingPJOsDayView day={day} model={m} key={day.Date} />
                                    )}
                                </div> :
                                <div className="placeholder-text">
                                    <div>All current movements have Pilot Orders.</div>
                                    {/* The assumption is that anyone who can see this popup can add pilot orders and thus
                                        must be able to add portcalls too. So we don't need a permissions check here. */}
                                    <div>Need new orders? <a href="#!addportcall">Add PortCall</a>.</div>
                                </div>
                            }
                            <div className="buttons">
                                <a href="" className="cancel-btn" onClick={noDefault(m.Cancel)}>Cancel</a>
                            </div>
                        </div>
                    }
                </div>
            </PCModal>
        </div>
    );
});

let MissingPJOsDayView = SuperCritical(({ day, model: m } : { day : MissingPJOsDayViewModel, model : AddPilotJobOrder }) =>
    <div className="day">
        <DateHeaderView moment={day.DateMoment} />
        <table className="missing-pjos">
            <thead>
                <tr>
                    <th className="pilot-flag">{/* Empty column header for pilot flag */}</th>
                    <th className="pc-text-smalllabel movement-type">Type</th>
                    <th className="pc-text-smalllabel est-time">Est.</th>
                    <th className="pc-text-smalllabel vessel">Vessel</th>
                    <th className="pc-text-smalllabel location">Location</th>
                    <th className="pc-text-smalllabel last-column"></th>
                </tr>
            </thead>
            <DayTableBody day={day} model={m} />
        </table>
    </div>
);

let DayTableBody = SuperCritical(({ day, model: m } : { day : MissingPJOsDayViewModel, model : AddPilotJobOrder }) =>
    <tbody className="pc-card">
        {day.MissingPJOs().map(pjo =>
            <MissingPJOView pjo={pjo} model={m} key={MissingPilotJobOrder.key(pjo)} />
        )}
    </tbody>
);

let MissingPJOView = SuperCritical(({ pjo, model: m } : { pjo : MissingPilotJobOrder, model : AddPilotJobOrder }) =>
    <tr className="missing-pjo" onClick={() => m.AddPilotJobOrder(pjo)}>
        <td className="pilot-flag"></td>
        <td className="movement-type">
            {
                pjo.Type() === MissingPilotJobOrderType.In ? 'IN' :
                pjo.Type() === MissingPilotJobOrderType.Shift ? 'SHIFT' :
                'OUT'
            }
        </td>
        <td className="est-time">{tzmoment(pjo.Date()).format('HH:mm')}</td>
        <td className="vessel">{pjo.VesselName()}</td>
        <td className="location">
            <span className={cx({
                    'is-not-berth': pjo.Type() === MissingPilotJobOrderType.In
                })}>
                {pjo.FromName()}
            </span>
            {' '}
            <span className="is-not-berth">to</span>
            {' '}
            <span className={cx({
                    'is-not-berth': pjo.Type() === MissingPilotJobOrderType.Out
                })}>
                {pjo.ToName()}
            </span>
        </td>
        <td></td>
    </tr>
);


// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/addpilotjoborderview.tsx